module.exports = __webpack_public_path__ + "img/broadband.49dd1e0.svg";